var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.queryForm.params,
                "label-width": "auto",
                size: "small",
                "label-position": "top",
              },
            },
            [
              _c(
                "div",
                { staticClass: "searchContainer" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.ContractNumber"),
                                prop: "contractNo",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseInput"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.queryForm.params.contractNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "contractNo",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.contractNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.CustomerName"),
                                prop: "customerId",
                              },
                            },
                            [
                              _c("QueryCustomerCmp", {
                                attrs: {
                                  val: _vm.queryForm.params.customerId,
                                  type: 1,
                                },
                                on: {
                                  change: function (val) {
                                    return (_vm.queryForm.params.customerId =
                                      val)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.ContractStatus"),
                                prop: "statusList",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                    multiple: "",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.statusList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "statusList",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.statusList",
                                  },
                                },
                                _vm._l(_vm.CONTRACT_STATUS, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", icon: "el-icon-search" },
              on: { click: _vm.searchResources },
            },
            [_vm._v(" " + _vm._s(_vm.$t("operationCenter.Procurar")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-refresh" },
              on: { click: _vm.onReset },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.reset")))]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c("div", { staticClass: "feet-s mb10" }, [
            _c(
              "div",
              { staticClass: "feet-r" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permit",
                        rawName: "v-permit:remove",
                        value: "btn:basicData:contractLedger:add",
                        expression: "'btn:basicData:contractLedger:add'",
                        arg: "remove",
                      },
                    ],
                    attrs: {
                      size: "small",
                      type: "primary",
                      icon: "el-icon-plus",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onAdd(1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("GlobalSetObj.add")))]
                ),
                _c(
                  "el-popover",
                  { attrs: { placement: "bottom-start", trigger: "hover" } },
                  [
                    _c(
                      "div",
                      { staticClass: "feet" },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value: "btn:basicData:contractLedger:export",
                                expression:
                                  "'btn:basicData:contractLedger:export'",
                                arg: "remove",
                              },
                            ],
                            staticClass: "feet-btn",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onExport(1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("basicData.ExportOnlyListData"))
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value: "btn:basicData:contractLedger:take",
                                expression:
                                  "'btn:basicData:contractLedger:take'",
                                arg: "remove",
                              },
                            ],
                            staticClass: "feet-btn",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onExport(2)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "basicData.FullExportWithoutInvalidScannedDocuments"
                                )
                              )
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value: "btn:basicData:contractLedger:exportAll",
                                expression:
                                  "'btn:basicData:contractLedger:exportAll'",
                                arg: "remove",
                              },
                            ],
                            staticClass: "feet-btn",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onExport(3)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "basicData.FullExportWithInvalidScannedDocuments"
                                )
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          slot: "reference",
                          size: "small",
                          type: "info",
                          icon: "el-icon-download",
                        },
                        slot: "reference",
                      },
                      [_vm._v(_vm._s(_vm.$t("receivablePayable.Export")))]
                    ),
                  ],
                  1
                ),
                _c("CustomStatusBar", {
                  staticClass: "feet-btn",
                  attrs: {
                    "columns-data": _vm.columns,
                    params: _vm.searchParams,
                    "save-params": _vm.customParams,
                  },
                  on: { updateColumns: _vm.updateColumns },
                }),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              key: _vm.tableKey,
              ref: "table",
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                height: _vm.tableHeightRow.height,
                border: "",
                "row-key": "idCopy",
                "tree-props": { children: "businessList", hasChildren: true },
                "default-expand-all": true,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { label: "", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isParent
                          ? _c("el-checkbox", {
                              attrs: { value: _vm.isChecked(scope.row) },
                              on: {
                                change: function ($event) {
                                  return _vm.handleCheckChange(
                                    scope.row,
                                    $event
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operationCenter.ind"),
                  width: "60px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isParent
                          ? _c("span", [_vm._v(_vm._s(scope.row.parentIndex))])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._l(_vm.currentColumns, function (item, ind) {
                return _c("el-table-column", {
                  key: ind,
                  attrs: {
                    prop: item.prop,
                    label: item.label,
                    align: item.align,
                    "min-width": item.width,
                    "show-overflow-tooltip": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "serialNo"
                              ? _c("span", { staticClass: "serialNo" }, [
                                  scope.row.isParent === true
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "batchNumber",
                                          on: {
                                            click: function ($event) {
                                              return _vm.view(2, scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.serialNo))]
                                      )
                                    : _vm._e(),
                                ])
                              : item.prop === "type"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.CONTRACT_TYPE[scope.row.type]
                                          ? _vm.CONTRACT_TYPE[scope.row.type]
                                              .label
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ])
                              : item.prop === "paymentDays"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.CONTRACT_PERIOD[
                                          scope.row.paymentDays
                                        ]
                                          ? _vm.CONTRACT_PERIOD[
                                              scope.row.paymentDays
                                            ].label
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ])
                              : item.prop === "status"
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.CONTRACT_STATUS[
                                            scope.row.status
                                          ]
                                            ? _vm.CONTRACT_STATUS[
                                                scope.row.status
                                              ].type
                                            : "info",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.CONTRACT_STATUS[
                                                scope.row.status
                                              ]
                                                ? _vm.CONTRACT_STATUS[
                                                    scope.row.status
                                                  ].label
                                                : ""
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : item.prop === "fileList"
                              ? _c("span", [
                                  _c(
                                    "div",
                                    { staticClass: "flex fileView" },
                                    [
                                      scope.row.fileList &&
                                      scope.row.fileList.length > 0
                                        ? [
                                            _vm._l(
                                              _vm.getDisplayFiles(
                                                scope.row.fileList
                                              ),
                                              function (key, index) {
                                                return _c(
                                                  "el-link",
                                                  {
                                                    key: key.id,
                                                    attrs: { type: "success" },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.previewFile(
                                                          scope.row,
                                                          _vm.getOriginalIndex(
                                                            scope.row.fileList,
                                                            key
                                                          )
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        key.fileOriginalName
                                                      )
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            scope.row.fileList.length > 3
                                              ? _c(
                                                  "el-popover",
                                                  {
                                                    attrs: {
                                                      placement: "bottom-start",
                                                      trigger: "hover",
                                                      "popper-class":
                                                        "file-list-popover",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "file-list-container",
                                                      },
                                                      _vm._l(
                                                        scope.row.fileList,
                                                        function (file, idx) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: file.id,
                                                              staticClass:
                                                                "file-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleFileClick(
                                                                      scope.row,
                                                                      idx
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "el-link",
                                                                {
                                                                  attrs: {
                                                                    type: "success",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      file.fileOriginalName
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _c(
                                                      "el-link",
                                                      {
                                                        attrs: {
                                                          slot: "reference",
                                                          type: "primary",
                                                        },
                                                        slot: "reference",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "...(" +
                                                            _vm._s(
                                                              scope.row.fileList
                                                                .length - 3
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row[item.prop])),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.operate"),
                  align: "center",
                  width: "180",
                  fixed: "right",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isParent
                          ? _c(
                              "div",
                              { staticClass: "flex" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit:remove",
                                        value:
                                          "btn:basicData:contractLedger:edit",
                                        expression:
                                          "'btn:basicData:contractLedger:edit'",
                                        arg: "remove",
                                      },
                                    ],
                                    staticClass: "ml",
                                    attrs: { size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(2, scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("basicData.View")))]
                                ),
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: {
                                      title: _vm.$t(
                                        "basicData.AreYouSureDelete"
                                      ),
                                    },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.Del(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    !scope.row.status
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permit",
                                                rawName: "v-permit:remove",
                                                value:
                                                  "btn:basicData:contractLedger:del",
                                                expression:
                                                  "'btn:basicData:contractLedger:del'",
                                                arg: "remove",
                                              },
                                            ],
                                            attrs: {
                                              slot: "reference",
                                              type: "danger",
                                              size: "mini",
                                            },
                                            slot: "reference",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("basicData.Delete"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100, 500],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getCurrentPage,
                  "size-change": _vm.getSizePage,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            visible: _vm.showDetail,
            "with-header": false,
            "wrapper-closable": false,
            direction: "ltr",
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetail = $event
            },
          },
        },
        [
          _c("Details", {
            key: _vm.detailKey,
            attrs: {
              "detail-type": _vm.detailType,
              "detail-data": _vm.detailData,
            },
            on: { closeDetail: _vm.closeDetail },
          }),
        ],
        1
      ),
      _vm.showPreviewDialog
        ? _c("FilePreview", {
            attrs: {
              "file-list": _vm.currenFileList,
              "file-index": _vm.currentPreviewFile,
            },
            on: { close: _vm.closeViewer },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }